const logsWeights = {
    DEBUG: {
        weight: 100,
        label: "Debug"
    },
    INFO: {
        weight: 200,
        label: "Info"
    },
    NOTICE: {
        weight: 250,
        label: "Notice"
    },
    WARNING: {
        weight: 300,
        label: "Warning"
    },
    ERROR: {
        weight: 400,
        label: "Error"
    },
    CRITICAL: {
        weight: 500,
        label: "Critical"
    },
    ALERT: {
        weight: 550,
        label: "Alert"
    },
    EMERGENCY: {
        weight: 600,
        label: "Emergency"
    }
}

export default logsWeights;


// WEBPACK FOOTER //
// ./src/constants/logsWeights.js